interface AppMetaOptions {
    version: string;
    environment: string;
}

const ensureMetaTag = (name: string, content: string) => {
    let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
    }
    tag.content = content;
};

export const applyAppMetaTags = ({ version, environment }: AppMetaOptions) => {
    ensureMetaTag("app-version", version);
    ensureMetaTag("app-environment", environment);
};
